import tokensApi from './api';
import tokensToasts from './toasts';

export default [tokensApi(), tokensToasts()];
